import { useT } from '@hostesa/i18n';
import { Button, EmptyState } from '@hostesa/ui';
import { Link } from '@tanstack/react-router';

/**
 * Operator no-access state. Shown when a non-operator (non-`hostesa_admin`)
 * session reaches the console, or when an operator lacks the permission/flag for
 * a specific route. It deliberately reveals nothing about tenant/hotel existence
 * (master prompt §13).
 */
export function NoAccessPage() {
  const { t } = useT('backoffice');
  return (
    <main
      data-testid="no-access-page"
      className="flex min-h-screen items-center justify-center bg-[var(--color-canvas)]"
    >
      <EmptyState
        title={t('noAccess.title')}
        description={t('noAccess.description')}
        action={
          <Button asChild variant="secondary" data-testid="no-access-back-btn">
            <Link to="/login">{t('noAccess.backToLogin')}</Link>
          </Button>
        }
      />
    </main>
  );
}

/** Generic catch-all not-found. */
export function NotFoundPage() {
  const { t } = useT('backoffice');
  return (
    <main
      data-testid="not-found-page"
      className="flex min-h-screen items-center justify-center bg-[var(--color-canvas)]"
    >
      <EmptyState
        title={t('notFound.title')}
        description={t('notFound.description')}
        action={
          <Button asChild variant="secondary" data-testid="not-found-back-btn">
            <Link to="/login">{t('notFound.backToLogin')}</Link>
          </Button>
        }
      />
    </main>
  );
}
